//@flow
import React from 'react';

import {makeStyles, Button, ButtonGroup} from '@material-ui/core';
import {colors} from '../../../../../../../../assets/styles/colors';
import CustomModal from '../../../../../../../../elements/CustomModal/CustomModal';
import ScheduleMessageForm from '../../../../../../schedule-messages/components/ScheduleMessageForm';
import {useToggle} from '../../../../../../../../utils/react';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    borderBlock: `1px solid ${colors.grey300}`,
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
  },

  actionButton: {
    color: colors.grey900,
    fontSize: '.875rem',
    width: '100%',
    textTransform: 'none',

    '&:hover': {
      backgroundColor: colors.grey100,
    },
  },
}));

export default function ChatActionBar() {
  const classes = useStyles();

  const [modalOpen, toggleModalOpen] = useToggle();
  return (
    <>
      <div className={classes.root}>
        <ButtonGroup
          variant="text"
          color="default"
          aria-label="text primary button group"
        >
          {/* <Button className={classes.actionButton}>Crea una tarea</Button> */}
          <Button className={classes.actionButton} onClick={toggleModalOpen}>
            Mensaje Programado
          </Button>
        </ButtonGroup>
      </div>

      <CustomModal open={modalOpen} handleCloseModal={toggleModalOpen}>
        <ScheduleMessageForm onSuccessfulSubmit={toggleModalOpen} />
        <br />
      </CustomModal>
    </>
  );
}
